import React, { useState } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import  HomePage  from "./screens/homePage";
import  ProductsPage  from "./screens/productsPage";
import  OrdersPage  from "./screens/ordersPage";
import  UserPage  from "./screens/userPage";
import  HomeNavBar  from "./components/headers/HomeNavBar";
import  OtherNavBar  from "./components/headers/OtherNavBar";
import  Footer  from "./components/footer";
import  HelpPage  from "./screens/helpPage";
import useBasket from "./hooks/useBasket";
import AuthenticationModal from "./components/auth";
import { sweetErrorHandling, sweetTopSmallSuccessAlert } from "../lib/sweetAlert";
import { Messages } from "../lib/config";
import MemberService from "./services/MemberService";
import { useGlobals } from "./hooks/useGlobals";
import "../css/app.css";
import "../css/navbar.css";
import "../css/footer.css";
import "../css/chat.css"
import AboutPage from "./screens/aboutPage";
import FloatingChat from "./components/floatingChat";



function App() {
    const location = useLocation();
    const {setAuthMember} = useGlobals();
    const {cartItems, onAdd, onRemove, onDelete, onDeleteAll} = useBasket();
    const [signupOpen, setSignupOpen] = useState<boolean>(false)
    const [loginOpen, setLoginOpen] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const {authMember} = useGlobals();


    /** HANDLER */
    const handleSignupClose = () => setSignupOpen(false);
    const handleLoginClose = () => setLoginOpen(false);
    const handleSwitchFromSignupToLogin = () => {
      setSignupOpen(false);
      setLoginOpen(true);
    };

    const handleLogoutClick = (e: React.MouseEvent<HTMLElement> ) => {
      setAnchorEl(e.currentTarget);
    };
    const handleCloseLogout = () => setAnchorEl(null);

    const handleLogoutRequest = async () => {
      try{
        const member = new MemberService();
        await member.logout();

        await sweetTopSmallSuccessAlert("seccess", 700)
        setAuthMember(null);

      } catch(err){
        console.log(err);
        sweetErrorHandling(Messages.error1)
      }
    }

    

  return (
          <>     
        {location.pathname === "/" 
          ? (<HomeNavBar 
            cartItems={cartItems} 
            onAdd={onAdd}
            onRemove={onRemove} 
            onDelete={onDelete} 
            onDeleteAll={onDeleteAll}
            setSignupOpen={setSignupOpen}
            setLoginOpen={setLoginOpen}
            anchorEl={anchorEl}
            handleLogoutClick={handleLogoutClick}
            handleCloseLogout={handleCloseLogout}
            handleLogoutRequest={handleLogoutRequest}
            />

           ) :  (
           <OtherNavBar 
            cartItems={cartItems} 
            onAdd={onAdd}
            onRemove={onRemove} 
            onDelete={onDelete} 
            onDeleteAll={onDeleteAll}
            setLoginOpen={setLoginOpen}
            anchorEl={anchorEl}
            handleLogoutClick={handleLogoutClick}
            handleCloseLogout={handleCloseLogout}
            handleLogoutRequest={handleLogoutRequest}
            />)}

        <Switch>
          <Route path="/products">
            <ProductsPage onAdd={onAdd} />
          </Route>
          <Route path="/orders">
            <OrdersPage />
          </Route>
          <Route path="/about">
            <AboutPage />
          </Route>
          <Route path="/member-page">
            <UserPage onAdd={onAdd} onLogout={handleLogoutRequest} />
          </Route>
          <Route path="/help">
            <HelpPage />
          </Route>
          <Route path="/">
          <HomePage />
          </Route>
        </Switch>
        <Footer/>

        {authMember && <FloatingChat />}


        <AuthenticationModal
        signupOpen={signupOpen}
        loginOpen={loginOpen}
        handleLoginClose={handleLoginClose}
        handleSignupClose={handleSignupClose}
        handleSwitchFromSignupToLogin={handleSwitchFromSignupToLogin}
        />


      </>
     
  );



 /* http://192.168.0.69:3000/ */

}

export default App
